import { axiosPrivate } from "./axios";

export const attendanceService = {
  /**
   * Get current user's attendance for today
   */
  getToday: async () => {
    const response = await axiosPrivate.get("/api/attendance/today");
    return response.data;
  },

  /**
   * Get current user's attendance history
   * @param {number} page
   * @param {number} limit
   */
  getMyHistory: async (page = 1, limit = 30) => {
    const response = await axiosPrivate.get("/api/attendance/my-history", {
      params: { page, limit },
    });
    return response.data;
  },

  /**
   * Admin: Get all attendance records
   * @param {object} params - { date, page, limit }
   */
  getAll: async ({ date, page = 1, limit = 50 } = {}) => {
    const params = { page, limit };
    if (date) params.date = date;
    const response = await axiosPrivate.get("/api/attendance/all", { params });
    return response.data;
  },

  /**
   * Admin: Manually trigger forgotten check-out resolution (same as midnight cron)
   */
  runForgottenCheckoutResolution: async () => {
    const response = await axiosPrivate.post(
      "/api/attendance/run-forgotten-checkout-resolution",
    );
    return response.data;
  },
};